import { SHOW_DIY_CARD } from '../src/constants';

export const MMT_HLD_VAR = [
  {
    mmtName: 'coachMarkExpire',
    pokusName: 'coachMarkExpire',
    defaultValue: 999,
  },
  {
    mmtName: 'coachmarkPageDesktop',
    pokusName: 'coachmarkPageDesktop',
    defaultValue: '[]',
  },
  {
    mmtName: 'showFreebiesPersuasions',
    pokusName: 'showFreebiesPersuasions',
    defaultValue: false,
  },
  {
    mmtName: 'standaloneTravelPlex',
    pokusName: 'standaloneTravelPlex',
    defaultValue: false,
  },
  {
    mmtName: 'HolAgentDiscoveryDT',
    pokusName: 'HolAgentDiscoveryDT',
    defaultValue: false,
  },
  {
    mmtName: 'HolAgentDetailDT',
    pokusName: 'HolAgentDetailDT',
    defaultValue: false,
  },
  {
    mmtName: 'showCovid',
    pokusName: 'showCovid',
    defaultValue: true,
  },
  {
    mmtName: 'showStory',
    pokusName: 'showStory',
    defaultValue: false,
  },
  {
    mmtName: 'mapCuratedPkgIds',
    pokusName: 'mapCuratedPkgIds',
    defaultValue: [],
  },
  {
    mmtName: 'mapImgs',
    pokusName: 'mapImgs',
    defaultValue: {
      theme: {},
      destinations: {},
    },
  },
  {
    mmtName: 'showPricesOnCalendar',
    pokusName: 'showPricesOnCalendar',
    defaultValue: false,
  },
  {
    mmtName: 'showSimilarPkgDest',
    pokusName: 'showSimilarPkgDest',
    defaultValue: false,
  },
  {
    mmtName: 'HideDiyPkgImage',
    pokusName: 'HideDiyPkgImage',
    defaultValue: false,
  },
  {
    mmtName: 'showHECardonDetail',
    pokusName: 'showHECardonDetail',
    defaultValue: false,
  },
  {
    mmtName: 'OnboardingCues_Listing',
    pokusName: 'OnboardingCues_Listing',
    defaultValue: {},
  },
  {
    mmtName: 'showPartPayment',
    pokusName: 'showPartPayment',
    defaultValue: false,
  },
  {
    mmtName: 'showDIYCard',
    pokusName: 'showDIYCard',
    defaultValue: SHOW_DIY_CARD.HIDE,
  },
  {
    mmtName: 'posDIYCard',
    pokusName: 'posDIYCard',
    defaultValue: 0,
  },
  {
    mmtName: 'mouseflowDesk',
    pokusName: 'mouseflowDesk',
    defaultValue: '0',
  },
  {
    mmtName: 'showIGOListing',
    pokusName: 'showIGOListing',
    defaultValue: false,
  },
  {
    mmtName: 'showActivityCollectionCard',
    pokusName: 'showActivityCollectionCard',
    defaultValue: false,
  },
  {
    mmtName: 'showHotelCollectionCard',
    pokusName: 'showHotelCollectionCard',
    defaultValue: false,
  },
  {
    mmtName: 'showNewQuoteCard',
    pokusName: 'showNewQuoteCard',
    defaultValue: false,
  },
  {
    mmtName: 'apiPokusListing',
    pokusName: 'apiPokusListing',
    defaultValue: 'apiPokusListing=true',
  },
  {
    mmtName: 'HolidaysCtaData',
    pokusName: 'HolidaysCtaData',
    defaultValue: {},
  },
  {
    mmtName: 'accordiansOrder',
    pokusName: 'accordiansOrder',
    defaultValue: {
      TRAVELLER_DETAILS: 0,
      PACKAGE_ADDONS: 1,
      PACKAGE_ITINERARY: 2,
      CANCELLATION_AND_DATECHANGE: 3,
    },
  },
  {
    mmtName: 'accordiansExpanded',
    pokusName: 'accordiansExpanded',
    defaultValue: {
      TRAVELLER_DETAILS: true,
      PACKAGE_ADDONS: false,
      PACKAGE_ITINERARY: false,
      CANCELLATION_AND_DATECHANGE: false,
    },
  },
  {
    mmtName: 'showCrmPaxV2',
    pokusName: 'showCrmPaxV2',
    defaultValue: true,
  },
  {
    mmtName: 'showPriceChangeDetails',
    pokusName: 'showPriceChangeDetails',
    defaultValue: false,
  },
  {
    mmtName: 'showGeoLocation',
    pokusName: 'showGeoLocation',
    defaultValue: false,
  },
  {
    mmtName: 'showRoadblock',
    pokusName: 'showRoadblock',
    defaultValue: true,
  },
  {
    mmtName: 'packageVariantType',
    pokusName: 'packageVariantType',
    defaultValue: 'NULL',
  },
  {
    // TODO: Remove this temp pokus after fixing the issue from commons
    mmtName: 'showPaxOnListing',
    pokusName: 'showPaxOnListing',
    defaultValue: false,
  },
  {
    mmtName: 'destinationSearchV2',
    pokusName: 'destinationSearchV2',
    defaultValue: true,
  },
  {
    mmtName: 'showNewSendQuoteView',
    pokusName: 'showNewSendQuoteView',
    defaultValue: true,
  },
  {
    mmtName: 'showAgentSection',
    pokusName: 'showAgentSection',
    defaultValue: true,
  },
  {
    mmtName: 'showNewDetails',
    pokusName: 'showNewDetails',
    defaultValue: false,
  },
  {
    mmtName: 'DeskPkgHighlights',
    pokusName: 'DeskPkgHighlights',
    defaultValue: false,
  },
  {
    mmtName: 'showReviewUpdateNew',
    pokusName: 'showReviewUpdateNew',
    defaultValue: false,
  },
  {
    mmtName: 'desktopCollapseFilter',
    pokusName: 'Desktop_Collapse_Filter',
    defaultValue: {},
  },
  {
    mmtName: 'showPDO',
    pokusName: 'mmt.desktop.common.default.homepage.default.showPDO',
    defaultValue: false,
  },
  {
    mmtName: 'showBookNowOnStoryPage',
    pokusName: 'showBookNowOnStoryPage',
    defaultValue: false,
  },
  {
    mmtName: 'acmeV3',
    pokusName: 'mmt.desktop.holiday.default.default.default.new_detail_v4_desktop',
    defaultValue: false,
  },
  {
    mmtName: 'HolidayShowListingV3Agent',
    pokusName: 'mmt.desktop.holiday.default.default.default.HolidayShowListingV3Agent',
    defaultValue: true,
  },
  {
    mmtName: 'HolidayShowListingV3Aff',
    pokusName: 'mmt.desktop.holiday.default.default.default.HolidayShowListingV3Aff',
    defaultValue: true,
  },
  {
    mmtName: 'listingCtaPopupDelay',
    pokusName: 'mmt.desktop.holiday.default.default.default.listingCtaPopupDelay',
    defaultValue: false,
  },
  {
    mmtName: 'showInsuranceSection',
    pokusName: 'mmt.desktop.holiday.default.review.default.showInsuranceSection_dt',
    defaultValue: false,
  },
  {
    mmtName: 'defaultDetailTabView',
    pokusName: 'mmt.desktop.holiday.default.detail.default.DefaultDetailTabView',
    defaultValue: { presales: 'SUMMARY', detailsV3: 'ITINERARY' },
  },
  {
    mmtName: 'mmtBlackReviewPopupDelay',
    pokusName: 'mmt.desktop.holiday.default.default.default.Review_Pop_Up_Desktop_Final',
    defaultValue: 2000,
  },
  {
    mmtName: 'mmtBlack',
    pokusName: 'mmt.desktop.common.default.homepage.default.HOLMMTBLACK',
    defaultValue: false,
  },
  {
    mmtName: 'holidaysExpertChat',
    pokusName: 'mmt.desktop.holiday.default.default.default.showHEChat',
    defaultValue: false,
  },
  {
    mmtName: 't2qqueryformflowsDT',
    pokusName: 't2qqueryformflowsDT',
    defaultValue: {
      isNewFabHeader: true,
      showPrivacyPolicy: false,
      isSingleStepSubmission: true,
    },
  },
  {
    mmtName: 'fabt2qconfigDT',
    pokusName: 'fabt2qconfigDT',
    defaultValue: {
      landing: {
        triggerTitle: 'Customise my trip<>',
        fallbackTitle: 'Customise my trip',
        triggerIconUrl:
          'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Chat%20bubble.png',
        QUERY: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Small%20Get%20a%20quote%20icon.png',
          text: 'Schedule a callback',
          subText: 'Customise your holiday to your liking',
          order: 1,
        },
        CALL: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Call%20t2q.png',
          text: 'Call Us',
          subText: 'Our experts are just a call away',
          order: 2,
        },
        CHAT: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Message.png',
          text: 'Chat with an Expert',
          subText: 'Get instant assistance at your fingertips',
          order: 3,
        },
        TRAVELPLEX: {
          iconUrl:
            'https://jsak.mmtcdn.com/pwa/platform-myra-ui/static/sub_icons/tp-new-animated-without-con.webp',
          text: 'Chat with an Expert',
          subText: 'Get instant assistance at your fingertips',
          order: 4,
        }
      },
      listing: {
        triggerTitle: 'Have questions about <context>?',
        fallbackTitle: 'Customise my trip',
        triggerIconUrl:
          'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Chat%20bubble.png',
        QUERY: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Small%20Get%20a%20quote%20icon.png',
          text: 'Schedule a callback',
          subText: 'Customise your holiday to your liking',
          order: 1,
        },
        CALL: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Call%20t2q.png',
          text: 'Call Us',
          subText: 'Our experts are just a call away',
          order: 2,
        },
        CHAT: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Message.png',
          text: 'Chat with an Expert',
          subText: 'Get instant assistance at your fingertips',
          order: 3,
        },
        TRAVELPLEX: {
          iconUrl:
            'https://jsak.mmtcdn.com/pwa/platform-myra-ui/static/sub_icons/tp-new-animated-without-con.webp',
          text: 'Chat with an Expert',
          subText: 'Get instant assistance at your fingertips',
          order: 4,
        }
      },
      details: {
        triggerTitle: 'Need help customizing this package? <>',
        fallbackTitle: 'Customise my trip',
        triggerIconUrl:
          'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Chat%20bubble.png',
        QUERY: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Small%20Get%20a%20quote%20icon.png',
          text: 'Schedule a callback',
          subText: 'Customise your holiday to your liking',
          order: 1,
        },
        CALL: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Call%20t2q.png',
          text: 'Call Us',
          subText: 'Our experts are just a call away',
          order: 2,
        },
        CHAT: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Message.png',
          text: 'Chat with an Expert',
          subText: 'Get instant assistance at your fingertips',
          order: 3,
        },
        TRAVELPLEX: {
          iconUrl:
            'https://jsak.mmtcdn.com/pwa/platform-myra-ui/static/sub_icons/tp-new-animated-without-con.webp',
          text: 'Chat with an Expert',
          subText: 'Get instant assistance at your fingertips',
          order: 4,
        }
      },
      review: {
        triggerTitle: 'Need help customizing this package? <>',
        fallbackTitle: 'Customise my trip',
        triggerIconUrl:
          'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Chat%20bubble.png',
        QUERY: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Small%20Get%20a%20quote%20icon.png',
          text: 'Schedule a callback',
          subText: 'Customise your holiday to your liking',
          order: 1,
        },
        CALL: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Call%20t2q.png',
          text: 'Call Us',
          subText: 'Our experts are just a call away',
          order: 2,
        },
        CHAT: {
          iconUrl:
            'https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/Message.png',
          text: 'Chat with an Expert',
          subText: 'Get instant assistance at your fingertips',
          order: 3,
        },
      },
      TRAVELPLEX: {
        iconUrl:
          'https://jsak.mmtcdn.com/pwa/platform-myra-ui/static/sub_icons/tp-new-animated-without-con.webp',
        text: 'Chat with an Expert',
        subText: 'Get instant assistance at your fingertips',
        order: 4,
      }
    },
  },
  {
    mmtName: 'fabt2qconfigUXDT',
    pokusName: 'fabt2qconfigUXDT',
    defaultValue: true,
  },
  {
    mmtName: 'pagination_DT',
    pokusName: 'pagination_DT',
    defaultValue: false,
  },
  {
    mmtName: 'showReviewAddonsDT',
    pokusName: 'showReviewAddonsDT',
    defaultValue: false,
  },
];

export const MMT_SESSION_ID = 'POKUS_DATA';
export const MMT_POKUS_VAR = 'POKUS_DATA_VAR';
